/**
 * An object containing a collection of cities and their respective districts.
 * The city keys contain another object where the keys are the district names in kebab-case and
 * the values are the human-readable district names.
 *
 * @type {Object<string, Object<string, string>>}
 * @example
 * {
 *   warszawa: {
 *     bialoleka: 'Białołęka',
 *     bemowo: 'Bemowo',
 *     // ...other districts
 *   },
 *   // ...other cities with their districts if available
 * }
 */
export const districts = {
  warszawa: {
    bialoleka: 'Białołęka',
    bemowo: 'Bemowo',
    bielany: 'Bielany',
    'brodno-podgrodzie': 'Bródno-Podgrodzie',
    ochota: 'Ochota',
    mokotow: 'Mokotów',
    'praga-poludnie': 'Praga-południe',
    'praga-polnoc': 'Praga-północ',
    rembertow: 'Rembertów',
    srodmiescie: 'Śródmieście',
    targowek: 'Targówek',
    ursus: 'Ursus',
    ursynow: 'Ursynów',
    wawer: 'Wawer',
    wesola: 'Wesoła',
    wilanow: 'Wilanów',
    wlochy: 'Włochy',
    wola: 'Wola',
    zoliborz: 'Żoliborz'
  }
};
